export const TOKEN_TYPE = 'Bearer';
